import cn from 'classnames';
import React from 'react';

import { EmptyResults } from '../../../images/analytics/EmptyResults';

import styles from './EmptyChart.module.scss';

export function EmptyPage() {
  return (
    <div className={cn(styles.pageWrapper, styles.wrapper)}>
      <div className={styles.image}>
        <EmptyResults />
      </div>
      <div className={styles.title}>No results found</div>
      <p className={styles.description}>Try adjusting your filters or resetting them to see the data.</p>
    </div>
  );
}
